import { useMutation } from '@tanstack/react-query';

import { organisationApi } from '../../apis/organisation';

export function useCreateOrganisation() {
  const mutation = useMutation({
    mutationFn: organisationApi.createOne,
  });

  return mutation;
}

export default useCreateOrganisation;
